/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";

const Permissions = ({ tableData, premissionV, inputChange }) => {
  const translation = useSelector((state) => state.root.translation);
  const isChecked = (value) => premissionV.includes(value);
  //
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    inputChange({ value, checked });
  };
  //
  return (
    <div className="table-responsive">
      <table className="table  datanew">
        <thead>
          <tr>
            <th>{translation["modules"]}</th>
            <th>{translation["create"]}</th>
            <th>{translation["view"]}</th>
            <th>{translation["update"]}</th>
            <th>{translation["delete"]}</th>
            <th>{translation["import"]}</th>
            <th>{translation["download"]}</th>
            <th>{translation["edit"]}</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((item, key) => {
            return (
              <tr key={key}>
                <td>{item.pagename}</td>
                <td>
                  {/* create */}
                  {item.Create && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Create}
                        checked={isChecked(item.Create)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* view */}
                  {item.View && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.View}
                        checked={isChecked(item.View)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* update */}
                  {item.Update && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Update}
                        checked={isChecked(item.Update)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* delete  */}
                  {item.Delete && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Delete}
                        checked={isChecked(item.Delete)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* import  */}
                  {item.Import && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Import}
                        checked={isChecked(item.Import)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* Download  */}
                  {item.Download && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Download}
                        checked={isChecked(item.Download)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
                <td>
                  {/* edit  */}
                  {item.Edit && (
                    <label className="checkboxs">
                      <input
                        type="checkbox"
                        value={item.Edit}
                        checked={isChecked(item.Edit)}
                        onChange={handleCheckboxChange}
                      />
                      <span className="checkmarks" />
                    </label>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Permissions;
